module.exports = __webpack_public_path__ + "img/art-29.70cd7e13.png";